import { render } from "./Rentals.vue?vue&type=template&id=7d8dbd2a"
const script = {}
script.render = render

export default script